(function () {
  function parseConfig(row) {
    var script = row.querySelector('[data-case-pack-config]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function lineProperties(row) {
    var dateInput = row && row.querySelector('[data-preorder-date]');
    if (!dateInput || !dateInput.value) return null;

    return {
      'Requested ship date': dateInput.value
    };
  }

  function parseItems(form) {
    return Array.from(form.querySelectorAll('[data-variant-id]'))
      .flatMap(function (input) {
        var quantity = parseInt(input.value, 10);
        if (!quantity || quantity < 1) return [];

        var row = input.closest('.bulk-order-list__row, tr');
        var properties = lineProperties(row);
        var config = row && parseConfig(row);

        if (config && Array.isArray(config.components) && config.components.length) {
          return config.components
            .map(function (component) {
              var variantId = Number(component.variant_id);
              var componentQuantity = Number(component.quantity || 0) * quantity;
              if (!variantId || componentQuantity < 1) return null;

              var item = {
                id: variantId,
                quantity: componentQuantity
              };
              if (properties) item.properties = properties;
              return item;
            })
            .filter(Boolean);
        }

        var item = {
          id: Number(input.dataset.variantId),
          quantity: quantity
        };
        if (properties) item.properties = properties;
        return item;
      })
      .filter(Boolean);
  }

  function setMessage(form, text) {
    var message = form.querySelector('[data-bulk-order-message]');
    if (message) message.textContent = text;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bulk-order-form]');
    if (!form) return;

    event.preventDefault();

    var items = parseItems(form);
    var button = form.querySelector('[data-bulk-order-submit]');
    if (!items.length) {
      setMessage(form, 'Enter at least one quantity.');
      return;
    }

    if (button) button.disabled = true;
    setMessage(form, 'Adding selected items...');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({items: items})
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        setMessage(form, 'Could not add the selected items. Check quantities and try again.');
        if (button) button.disabled = false;
      });
  });
})();
